import React from "react";
import { Button, Carousel } from "antd";
import Images from "../../Images";
import LiveMatches from "./LiveMatches";
import SportCategories from "./SportCategories";
import Promos from "./Promos";

export class HomeCourasel extends React.Component {
  state = {
    currentSlide: 0,
    numSlides: 0,
  };

  componentDidMount() {
    this.setState({ numSlides: this.carouselRef.innerSlider.state.slideCount });
  }

  onArrowClick = (direction) => {
    const { currentSlide, numSlides } = this.state;

    switch (direction) {
      case "prev":
        if (currentSlide > 0) {
          this.carouselRef.prev();
        }
        break;

      case "next":
        if (currentSlide < numSlides - 1) {
          this.carouselRef.next();
        }
        break;
    }
  };
  handleTouchpadScroll = (event) => {
    const deltaX = event.deltaX;
    const {startScroll}=this.state
    if(this.time) clearTimeout(this.time)
    if(!startScroll){
      if(deltaX > 0){
        this.onArrowClick("next")
        this.setState({startScroll: true})
      }else if(deltaX < 0){
        this.onArrowClick("prev")
        this.setState({startScroll: true})
      }
    }
    this.time=setTimeout(()=>{
      this.setState({
        startScroll: false
      })
    },300)
    
  }
  getTabPanelBySport(sport) {
    const {history}=this.props
    const sportFeedId = sport.feed.feedId
    const sportId = sport.sport.sportId;
    const sportName = sport.sport.sportDisplayName;
    const { sportTypesIcons } = this.props;
    const img =  sportTypesIcons && sportTypesIcons.filter((item) => {
      return item.sportTypesIconsID == sportId && item.feedId == sportFeedId;
    });
    const src = () => {
      return img && img[0] ? `${img[0].sportTypesIconsName}?id=${img[0].imageVersion}` : ''; //`${AppConfig.api.sportIcons}${sportName.toString().replace(/ /g, '')}.webp`
    };
    // <section className="sport-icons-container" onClick={() => this.onSportClick(sport)}
    // >
    //   <img
    //     className="tab mobile-view-images"
    //     src={src()}
    //     alt="sport-icons"
    //   />
    //   <span className="sport-display-name" style={{ color: `${sport.sportColor}` }}>{sportName}</span>
    // </section>
    return (
      <SportCategories sportName={sportName} sportColor={sport.sportColor} sportImage={src()} sport={sport} history={history}/>
    );
  }

  render() {
    const {sportTypesIcons , sportTypes , history , landingPromos , navUrl} =this.props
    const { currentSlide, numSlides } = this.state;
    const prevDisabled = currentSlide === 0;
    const nextDisabled = this.props.isMobile
      ? this.props.type == "Sports"
        ? currentSlide == numSlides - 3
        : currentSlide === numSlides - 1
      : this.props.type == "Sports"
      ? currentSlide == numSlides - 6
      : currentSlide === numSlides - 3;
    return (
      <div className="home-courasel">
        <div className="courasel-nav">
          
            <h2 onClick={()=>history.push(navUrl)}>{this.props.title}</h2>
    
          <div className="arrows-container">
            <button
              disabled={prevDisabled}
              onClick={() => this.onArrowClick("prev")}
            >
              <img src={Images.LT} alt="previous-arrow" />
            </button>
            <button
              disabled={nextDisabled}
              onClick={() => this.onArrowClick("next")}
            >
              <img className="next-arrow" src={Images.LT} alt="next-arrow" />
            </button>
          </div>
        </div>
        <div onWheel={this.handleTouchpadScroll}>
        <Carousel
          ref={(ref) => (this.carouselRef = ref)}
          slidesToShow={
            this.props.isMobile
              ? this.props.type == "Sports"
                ? 3
                : 1
              : this.props.type == "Sports"
              ? 6
              : 3
          }
          dots={false}
          effect="scrollx"
          infinite={false}
          autoplay={false}
          afterChange={(current) => this.setState({ currentSlide: current })}
        >
          {this.props.type == "Live"
            ? Array.from(Array(6).keys()).map((item, key) => {
                return <LiveMatches />;
              })
            : this.props.type == "Sports"
            ? sportTypes && sportTypes.map((sport) => {
              return this.getTabPanelBySport(sport);
             })
            : this.props.type == "Promos"
            ? landingPromos.map((promo) => {
                return <Promos promo={promo} history={history}/>;
              })
            : ""}
        </Carousel>
        </div>

      </div>
    );
  }
}

export default HomeCourasel;
